import { render, staticRenderFns } from "./indexProject.vue?vue&type=template&id=0c1c7f72"
import script from "./indexProject.vue?vue&type=script&lang=js"
export * from "./indexProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports